export const AnalyticsTypes = {
    TrackEvent: 0,
    ChangePageView: 1,
};

function prefixWithTags(action, category, tags) {
    const buildingPrefixes = [];

    if (category && category !== '') {
        buildingPrefixes.push(`[${category}]`);
    }

    if (tags) {
        buildingPrefixes.push(`[${tags}]`);
    }

    buildingPrefixes.push(action);

    return buildingPrefixes.join(' ');
}

function getEventTrackingObject(data) {
    const listedCategory = data.category || '';
    const options = Object.assign({}, data.options);
    const listedAction = prefixWithTags(data.action, data.category, options.tags) || '';

    return {
        hitType: 'event',
        eventCategory: listedCategory,
        eventAction: listedAction,
        eventLabel: options.label,
        eventValue: options.value,
    };
}

function trackEventWithData(tracker, data) {
    tracker('send', getEventTrackingObject(data));
}

export function createAnalyticsLogger(ga) {
    const _gaEventQueue = [];
    let _gaCheckLoop;

    function checkingLoop() {
        const tracker = window.ga;

        if (!tracker) {
            return;
        }

        clearInterval(_gaCheckLoop);
        _gaCheckLoop = undefined;

        for (const action of _gaEventQueue) {
            processAction(action, tracker);
        }
    }

    function processAction(action, tracker) {
        switch (action.meta.analytics.type) {
            case AnalyticsTypes.TrackEvent:
                trackEventWithData(tracker, action.meta.analytics);
                break;
            case AnalyticsTypes.ChangePageView:
                tracker('set', 'page', action.meta.analytics.page);
                tracker('send', 'pageview');
                break;
            default:
                throw new Error('Please specify a valid analytics type');
        }
    }

    return () => next => action => {
        ga = window.ga || ga;
        const result = next(action);

        if (action.meta) {
            if (action.meta.analytics) {
                if (!ga) {
                    _gaEventQueue.push(action);

                    if (!_gaCheckLoop) {
                        _gaCheckLoop = setInterval(checkingLoop, 100);
                    }
                } else {
                    processAction(action, ga);
                }
            }
        }

        return result;
    };
}

const analyticsLogger = createAnalyticsLogger();
analyticsLogger.withTracker = createAnalyticsLogger;

export { analyticsLogger };
